import React, { useState, useEffect } from 'react';
import AdvisorCard from './advisors/AdvisorCard';
import logger from '../utils/logger';

export const AdminAdvisorManagement = () => {
  const [advisors, setAdvisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copiedUrl, setCopiedUrl] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchAdvisors = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch(`${API_URL}/api/admin/advisors`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setAdvisors(data.advisors || []);
      }
    } catch (err) { logger.error('Failed to fetch advisors:', err); }
    setLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchAdvisors(); }, []);

  const regenerateToken = async (advisorId) => {
    const token = localStorage.getItem('auth_token');
    const res = await fetch(`${API_URL}/api/admin/advisors/${advisorId}/regenerate-token`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (res.ok) fetchAdvisors();
  };

  const deactivateAdvisor = async (advisorId) => {
    const token = localStorage.getItem('auth_token');
    const res = await fetch(`${API_URL}/api/admin/advisors/${advisorId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (res.ok) {
      setConfirmDelete(null);
      fetchAdvisors();
    }
  };

  const copyPortalUrl = (portalUrl) => {
    const fullUrl = `${window.location.origin}${portalUrl}`;
    navigator.clipboard.writeText(fullUrl);
    setCopiedUrl(portalUrl);
    setTimeout(() => setCopiedUrl(null), 2000);
  };

  if (loading) {
    return (
      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700" data-testid="advisor-management">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-bold text-white">Trusted Professional Management</h3>
          <p className="text-sm text-gray-400 mt-1">{advisors.length} trusted professional{advisors.length !== 1 ? 's' : ''} registered</p>
        </div>
      </div>

      {advisors.length === 0 ? (
        <p className="text-gray-400 text-center py-8">No trusted professionals registered yet.</p>
      ) : (
        <div className="space-y-4">
          {advisors.map((advisor) => (
            <AdvisorCard
              key={advisor.advisor_id}
              advisor={advisor}
              onCopyUrl={copyPortalUrl}
              onRegenerate={regenerateToken}
              onDelete={deactivateAdvisor}
              copiedUrl={copiedUrl}
              confirmDelete={confirmDelete}
              setConfirmDelete={setConfirmDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};
